var classList = require('dom-classlist'); 
var gsap = require('gsap');

module.exports = function () {
 
    if(!document.querySelector('.collapsible')) return;
 
    var collapsible = document.querySelector('.collapsible')
    ,   cols = collapsible.querySelector('.columns')
    ,   trigger = collapsible.querySelector('.btnNext')
    ,   isOpen = false;


    var init = function(){
        if(trigger){
            trigger.addEventListener('click', function(){
           
                if(isOpen){
                    TweenLite.to(cols, 0.2, {height:0, ease: Power1.easeIn})
                    trigger.innerHTML = '+';
                } else {
                    TweenLite.set(cols, {height:"auto"})
                    TweenLite.from(cols, 0.2, {height:0, ease: Power1.easeOut })
                    trigger.innerHTML = '-';
                }
    
                isOpen = !isOpen;
                
            })
        }
       
 
        if(classList(collapsible).contains('open')){
            TweenLite.set(cols, {height:"auto"})
            TweenLite.from(cols, 0.2, {height:0, ease: Power1.easeOut })
            trigger.innerHTML = '-';
            isOpen = true;
        }
    }
 

    init();
     
}